/** Please don't modify or unzip this content. It will be updated regularly **/
(function() {
    BoostPFS.inject(this);

    //Set global variable
    Globals.hasIntegration = true;

    // 3rd app compile template
    Integration.compileIntegrationTemplate = function(data, itemHtml) {
        var ssw_count_rate = 0;
        var ssw_avg_rate = 0;
        var sswReviewsHtml = '';
        
        // Check for unite_review first, if not available fall back to review
        var ssw_rate_data = Utils.getProductMetafield(data, 'ssw', 'unite_review');
        if (ssw_rate_data === null) {
            ssw_rate_data = Utils.getProductMetafield(data, 'ssw', 'review');
        }

        if (ssw_rate_data !== null) {
            ssw_rate_data = JSON.parse(ssw_rate_data);
            ssw_count_rate = ssw_rate_data['count'];
            ssw_avg_rate = ssw_rate_data['avg'];
        }

        sswReviewsHtml += '<div class="ssw-widget-avg-rate-listing ssw-stars ssw-stars-large ';
        if (ssw_count_rate == 0) {
            sswReviewsHtml += 'ssw-hide';
        }
        sswReviewsHtml += '">';
        
        var ssw_j = Math.floor(ssw_avg_rate);
        for (var i = 1; i <= ssw_j; i++) {
            sswReviewsHtml += '<i class="ssw-icon-star"></i>';
        }
        
        var ssw_rate_last_star = 5 - ssw_avg_rate;
        var ssw_y = Math.floor(ssw_rate_last_star);
        var ssw_x = ssw_avg_rate - ssw_j;

        if (ssw_x > 0.74) {
            sswReviewsHtml += '<i class="ssw-icon-star"></i>';
        } else {
            if (ssw_x > 0.24) {
                sswReviewsHtml += '<i class="ssw-icon-star-half-alt"></i>';
            } else {
                if (ssw_x > 0) {
                    ssw_y = ssw_y + 1;
                }
            }
        }

        for (var j = 0; j < ssw_y; j++) {
            sswReviewsHtml += '<i class="ssw-icon-star-empty"></i>';
        }

        sswReviewsHtml += '<span class="ssw-review-count">(' + ssw_count_rate + ')</span>';
        sswReviewsHtml += '</div>';
        
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, sswReviewsHtml);
        
        return itemHtml;
    };

    Integration.call3rdIntegrationFunc = function(data) {
        
    }

})();